var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Line",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 22,
    viewBox: "0 0 19 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_34166",
    "data-name": "Path 34166",
    d: "M14.427,2A7.435,7.435,0,0,0,6.994,9.438v5.8L5.349,17.719a2.023,2.023,0,0,0,1.68,3.124h4.425a2.973,2.973,0,1,0,5.946,0h4.425A2.023,2.023,0,0,0,23.5,17.7L21.86,15.239v-5.8A7.435,7.435,0,0,0,14.427,2Zm0,20.826a1.983,1.983,0,0,1-1.982-1.983h3.964A1.983,1.983,0,0,1,14.427,22.826Zm8.251-4.572a.992.992,0,0,1,.173.57,1.026,1.026,0,0,1-1.026,1.026H7.028A1.026,1.026,0,0,1,6,18.824a.992.992,0,0,1,.173-.57L7.9,15.661a.5.5,0,0,0,.084-.273V9.438a6.442,6.442,0,1,1,12.884,0v5.95a.5.5,0,0,0,.084.273Z",
    transform: "translate(-4.932 -1.909)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_34166_-_Outline",
    "data-name": "Path 34166 - Outline",
    d: "M14.368,1.85a7.527,7.527,0,0,1,7.524,7.529v5.774l1.63,2.441a2.115,2.115,0,0,1-1.756,3.281H17.431a3.064,3.064,0,0,1-6.126,0H6.97A2.115,2.115,0,0,1,5.213,17.61l1.63-2.457V9.379A7.527,7.527,0,0,1,14.368,1.85Zm7.4,18.842a1.932,1.932,0,0,0,1.6-3l-1.66-2.487V9.379a7.342,7.342,0,1,0-14.683,0v5.829l-1.66,2.5a1.932,1.932,0,0,0,1.6,2.982h4.516v.091a2.882,2.882,0,1,0,5.764,0v-.091Zm-7.4-17.85A6.535,6.535,0,0,1,20.9,9.379v5.95a.4.4,0,0,0,.069.222l1.725,2.594a1.077,1.077,0,0,1,.189.622,1.119,1.119,0,0,1-1.117,1.117H6.97a1.119,1.119,0,0,1-1.117-1.118,1.078,1.078,0,0,1,.189-.622l1.724-2.592a.4.4,0,0,0,.069-.223V9.379a6.535,6.535,0,0,1,6.533-6.537Zm7.4,16.859a.936.936,0,0,0,.934-.935.9.9,0,0,0-.157-.519l-1.725-2.594a.585.585,0,0,1-.1-.323V9.379a6.35,6.35,0,1,0-12.7,0v5.95a.586.586,0,0,1-.1.324L6.193,18.246a.9.9,0,0,0-.158.519.936.936,0,0,0,.934.936Zm-9.472.992h4.147v.091a2.073,2.073,0,1,1-4.147,0Zm3.962.183H12.479a1.891,1.891,0,0,0,3.777,0Z",
    transform: "translate(-4.873 -1.85)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.d4f0c9c83347f651964ad478210b5b38.svg";
export { ForwardRef as ReactComponent };